import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  TextField, PasswordField, Button, LoadingIndicator, ErrorMessage, AuthWrapper,
} from '../components';

const styles = theme => ({
  buttonStyle: {
    width: '100%',
    fontWeight: 'bold',
  },
  formGroupStyle: {
    width: '100%',
    textAlign: 'center',
    marginTop: 10,
  },
  inputStyle: {
    width: '100%',
  },
  copyrightStyle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  link: {
    color: theme.palette.link.main,
  },
});

class Login extends Component {
  constructor(props) {
    super(props);
    const { userName } = this.props;
    this.state = {
      userName: userName || '',
      password: '',
    };
  }

  setUsername = (event) => {
    this.setState({ userName: event.target.value });
  }

  setPassword = (event) => {
    this.setState({ password: event.target.value });
  }

  keyPress = (event) => {
    if (event.key === 'Enter') {
      this.login();
      event.preventDefault();
      return false;
    }
    return true;
  }

  login = () => {
    const { login } = this.props;
    const { userName, password } = this.state;


    if (userName && userName !== '' && password && password !== '') {
      login({ userName, password });
    }
  }

  renderLoginButton = () => {
    const { isLoading, classes } = this.props;

    if (isLoading) {
      return <LoadingIndicator />;
    }
    return (
      <Button
        onClick={this.login}
        label="Login"
        color="primary"
        variant="contained"
        className={classes.buttonStyle}
      />
    );
  }

  render() {
    const {
      classes, inApp, mail, telnr, copyrightBy, forgotPassword, customNotification, errorMessage, logo,
    } = this.props;
    const { userName, password } = this.state;

    if (inApp) {
      return null;
    }

    return (
      <AuthWrapper logo={logo} onKeyPress={this.keyPress}>
        <form noValidate>
          <ErrorMessage errorMessage={errorMessage} />
          <div
            className={classes.formGroupStyle}
            style={{
              marginTop: 15,
            }}
          >
            <TextField
              autoFocus
              required
              fullWidth
              className={classes.inputStyle}
              placeholder="Username"
              value={userName}
              onChange={this.setUsername}
              autoComplete="username"
            />
          </div>
          <div className={classes.formGroupStyle}>
            <PasswordField
              required
              fullWidth
              className={classes.inputStyle}
              placeholder="Passwort"
              value={password}
              onChange={this.setPassword}
              autoComplete="password"
            />
          </div>
          <div
            className={classes.formGroupStyle}
            style={{
              marginTop: 40,
              paddingBottom: 45,
            }}
          >
            {this.renderLoginButton()}
            {forgotPassword}
          </div>
        </form>
        <div>
          { mail
            && <a href={`mailto:${mail}`} className={classes.link}>{mail}</a>
            }

          <span>
            { mail && telnr
              && ' | '
              }
            { telnr }
          </span>
        </div>
        <div className={classes.copyrightStyle}>
          ©
          {' '}
          {copyrightBy}
          {' '}
          {new Date().getFullYear()}
        </div>
        {customNotification}
      </AuthWrapper>
    );
  }
}


Login.propTypes = {
  login: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  inApp: PropTypes.bool,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  logo: PropTypes.string.isRequired,
  mail: PropTypes.string,
  telnr: PropTypes.string,
  copyrightBy: PropTypes.string,
  forgotPassword: PropTypes.element,
  customNotification: PropTypes.element,
  userName: PropTypes.string,
};

Login.defaultProps = {
  isLoading: false,
  errorMessage: null,
  inApp: false,
  mail: null,
  telnr: null,
  forgotPassword: null,
  customNotification: null,
  userName: '',
  copyrightBy: null,
};

export default withStyles(styles)(Login);
